const serverMutators = (target) => {
  const addServer = (server) => {
    if (!target) {
      return false;
    }
    target.push(server);
    return true;
  };
  const deleteServer = (url) => {
    if (!target) {
      return false;
    }
    const newTarget = [...target.filter((it) => it.url !== url)];
    target.splice(0, target.length);
    target.push(...newTarget);
    return true;
  };
  return {
    addServer,
    deleteServer
  };
};
export {
  serverMutators
};
//# sourceMappingURL=server.js.map
